<!--
* @description  参数1
* @fileName  totalShipment
* @author userName
* @date 2024-01-08 09:56:30
!-->
<template>
  <div id="totalShipment" class="totalShipment">
    <div class="totalShipment-tip">
      <span> 按总发货量计算不太准确，因此更有可能因尺寸不准确或尺寸过大而产生额外费用。</span>
    </div>
    <div class="form-class main-info check-price-form" style="width: 100%">
      <el-form
        ref="formData"
        :model="formData"
        :rules="allRules"
        label-position="top"
        size="medium"
        class="item-Surcharge"
        @submit.native.prevent
      >
        <div class="form-item">
          <el-form-item class="flex-width_1" prop="quantity" label="件数">
            <el-input-number
              v-model="formData.quantity"
              style="width: 186px"
              :min="1"
              :max="9999"
              label=""
              @change="handleChange"
            />
          </el-form-item>
          <el-form-item class="flex-width_2" prop="volume" label="总体积">
            <el-input
              v-model="formData.volume"
              v-inputNumber="{ type: 'float', number: 3 }"
              style="width: 236px"
              placeholder="请输入"
              @focus="inputSelect($event)"
            >
              <template slot="append">
                <el-form-item prop="volumeUnit">
                  <el-select v-model="formData.volumeUnit" @change="volumeUnitChange">
                    <el-option
                      v-for="item in volumeUnitOptions"
                      :key="item.label"
                      :value="item.value"
                      :label="item.label"
                    />
                  </el-select>
                </el-form-item>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item class="flex-width_2" prop="weight" label="总重量">
            <el-input
              v-model="formData.weight"
              v-inputNumber="{ type: 'float', number: 3 }"
              style="width: 236px"
              placeholder="请输入"
              @focus="inputSelect($event)"
            >
              <template slot="append">
                <el-form-item prop="weightUnit">
                  <el-select v-model="formData.weightUnit">
                    <el-option
                      v-for="item in weightUnitOptions"
                      :key="item.label"
                      :value="item.value"
                      :label="item.label"
                    />
                  </el-select>
                </el-form-item>
              </template>
            </el-input>
          </el-form-item>
        </div>
      </el-form>
    </div>
	<div class="foot-button">
	  <button type="button" :class="['confirm-button', { 'confirm-button-ok': isAllOk }]" @click.stop="confirm">
	    确定
	  </button>
	</div>
  </div>
</template>

<script>
export default {
  name: 'TotalShipment',
  components: {
    // 组件的引用
  },
  props: {
    // 父辈向子辈传参
  },
  data() {
    return {
      formData: {
        quantity: '',
        volume: '',
        weight: '',
        volumeUnit: 'CBM',
        weightUnit: 'KG'
      },
      volumeUnitOptions: [{
        value: 'CBM',
        label: 'CBM'
      },
      {
        value: 'CFT',
        label: 'CFT'
      }
      ],
      weightUnitOptions: [{
        value: 'KG',
        label: 'KG'
      },
      {
        value: 'LB',
        label: 'LB'
      }
      ],
      allRules: {
        quantity: [{
          required: true,
          trigger: 'blur',
          message: 'required'
        }],
        volume: [{
          required: true,
          trigger: 'blur',
          message: 'required'
        }],
        weight: [{
          required: true,
          trigger: 'blur',
          message: 'required'
        }]
      }
    }
  },
  computed: {
    // 计算属性
    isAllOk() {
      return this.formData.quantity && this.formData.volume && this.formData.weight
    }
  },
  watch: {
    // 监测变化
  },
  created() {
    // 实例被创建之后执行代码
  },
  mounted() {
    // 页面进入时加载内容
  },
  methods: {
    init(data) {
      this.formData = data
    },
    volumeUnitChange(val) {
      if (val === 'CBM') {
        this.formData.weightUnit = 'KG'
      } else {
        this.formData.weightUnit = 'LB'
      }
    },
    // 方法
    handleChange(value) {
      console.log(value)
    },
    inputSelect(e) {
      e.target.select()
    },
    confirm() {
      this.$refs.formData.validate(valid => {
		  var totalInfo = {
		    weight: 0,
		    volume: 0,
		    quantity: 0
		  }
		  if (valid) {
			  totalInfo.weight = this.formData.weight
			  if (this.formData.weightUnit === 'LB') {
			    totalInfo.weight = (this.formData.weightUnit * 0.4535924).toFixed(2)
			  }
			  totalInfo.volume = this.formData.volume
			  if (this.formData.volumeUnit === 'CFT') {
			    totalInfo.volume = (this.formData.volume * 0.0283168).toFixed(2)
			  }
			  totalInfo.quantity = this.formData.quantity
			  this.$emit('next', totalInfo, this.formData)
		  }
      })
    }
  }
}
</script>
<style scoped lang='scss'>
	.totalShipment {
		margin: 8px 16px 16px;

		.totalShipment-tip {
			width: 100%;
			height: 40px;
			background: rgba(51,112,255,0.04);
      border-radius: 4px;
			text-align: left;

			span {
				padding: 11px 8px;
        display: inline-block;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 13px;
        color: #3370FF;
        line-height: 18px;
        text-align: left;
        font-style: normal;
			}
		}

		.form-item {
			display: flex;

			::v-deep .el-form-item {
				margin-bottom: 0;

				.el-form-item__label {
					float: left;
					padding: 0;
					margin-top: 4px;
				}

				.el-input__inner {
					height: 40px !important;
				}

				.el-form-item__content {
					.el-input-number {
						// span {
						// 	height: 38px;
						// }
					}
				}

				.el-input-number {

					.el-input-number__decrease,
					.el-input-number__increase {
						width: 24px;
						height: 24px;
						background: rgba(170, 170, 170, 0.16);
						border-radius: 4px;
						margin: 8px;
						border: 0px;
						display: flex;
						align-items: center;
						justify-content: center;

						i {
							font-weight: bold !important;
							color: #272636 !important;

						}
					}

				}
			}

			.flex-width_1,
			.flex-width_2,
			.flex-width_3 {
				margin-right: 16px;
			}

			::v-deep .flex-width_2 {
				.el-form-item__content {
					.el-input {
						.el-input-group__append {
							width: 80px;
              box-sizing: border-box;
						}
					}
				}
			}
		}

		.foot-button {
		  margin: 16px 0;
		  display: flex;
		  justify-content: end;
		
		  .add-button {
		    width: 100%;
		    height: 48px;
		    background: rgba(247, 248, 250, 0.56);
		    border-radius: 8px;
		    border-radius: 4px;
		    border: 1px solid #dddddd;
		    font-family: PingFangSC, PingFang SC;
		    font-weight: 400;
		    font-size: 13px;
		    color: #333333;
		    line-height: 20px;
		    text-align: center;
		    font-style: normal;
		    transition: all 0.3s;
		
		    &:hover {
		      cursor: pointer;
		      background: rgba(51, 112, 255, 0.04);
		      border: 1px solid rgba(51, 112, 255, 0.8);
		      color: #3370ff;
		    }
		  }
		
		  .confirm-button-ok {}
		
		  .confirm-button {
		    width: 88px;
		    height: 32px;
		    background: #3370ff;
		    border-radius: 8px;
		    font-family: PingFangSC, PingFang SC;
		    font-weight: 600;
		    font-size: 14px;
		    color: #ffffff;
		    line-height: 22px;
		    text-align: center;
		    font-style: normal;
		    color: #ffffff;
		    border: 0;
		
		    &:hover {
		      cursor: pointer;
		      background: #3370ff;
		    }
		
		    &:active {
		      cursor: pointer;
		      background: #3370ff;
		    }
		  }
		}
	}
</style>
